// Google Analytics 4 — chargé uniquement si REACT_APP_GA_ID est configuré
let gaId = null;
let lastPageLocation = null;

function getConfiguredId() {
  const value = process.env.REACT_APP_GA_ID?.trim();
  return value && /^G-[A-Z0-9]+$/i.test(value) ? value : null;
}

export function initAnalytics() {
  if (gaId) return;
  const id = getConfiguredId();
  if (!id || typeof document === "undefined") return;
  gaId = id;

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  window.gtag("js", new Date());
  window.gtag("config", id, { send_page_view: false });

  if (!document.querySelector(`script[data-ga4="${id}"]`)) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
    script.dataset.ga4 = id;
    document.head.appendChild(script);
  }
}

export function trackPageView() {
  if (!gaId || typeof window === "undefined") return;
  const pageLocation = window.location.href;
  if (pageLocation === lastPageLocation) return;
  lastPageLocation = pageLocation;
  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: pageLocation,
  });
}
